import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { PayStationDevice } from 'src/features/payStations/types';
import type { ListDTO } from 'src/types';

const RESOURCE = '/paystations/:payStationId/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    payStationId: string;
}

const queryFn = ({ payStationId, ...params }: DTO): Promise<PayStationDevice> => {
    return axios.get(formatResourcePath(RESOURCE, { payStationId }), { params });
};

interface UseQueryHookOptions extends ListDTO {
    payStationId: string;
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });
};

export { useQueryHook as useGetPayStation };
